import CheckIcon from '@mui/icons-material/Check'
import React from 'react'

const ACCENT = 'rgb(var(--k-primary))'

export interface FormStepperProps {
    labels: string[]
    step: number
    /** Último paso alcanzado; los posteriores quedan bloqueados. */
    maxStep: number
    isOk: (index: number) => boolean
    onStep: (index: number) => void
    ariaLabel?: string
}

const gridCols: Record<number, string> = { 2: 'grid-cols-2', 3: 'grid-cols-3', 4: 'grid-cols-4', 5: 'grid-cols-5' }

const FormStepper = ({ labels, step, maxStep, isOk, onStep, ariaLabel = 'Pasos de la captura' }: FormStepperProps) => {
    const last = labels.length - 1
    return (
        <ol aria-label={ariaLabel} className={`m-0 grid list-none ${gridCols[labels.length] || 'grid-cols-4'} gap-0 rounded-[18px] border border-k-line bg-k-surface px-2 pb-2 pt-2.5`}>
            {labels.map((label, i) => {
                const cur = i === step
                const past = i < step
                const locked = i > maxStep
                const ok = past && isOk(i)
                return (
                    <li key={label} className="relative flex min-w-0 flex-col items-center gap-1.5">
                        {i > 0 && <span aria-hidden className="absolute top-4 right-1/2 left-0 h-[3px]" style={{ background: past || cur ? ACCENT : 'rgb(var(--k-line-strong))' }} />}
                        {i < last && <span aria-hidden className="absolute top-4 left-1/2 right-0 h-[3px]" style={{ background: past ? ACCENT : 'rgb(var(--k-line-strong))' }} />}
                        <button
                            type="button"
                            disabled={locked}
                            aria-current={cur ? 'step' : undefined}
                            aria-label={`Paso ${i + 1}: ${label}`}
                            onClick={() => onStep(i)}
                            className="relative z-[1] flex h-[34px] w-[34px] items-center justify-center rounded-full border-0 text-[13px] font-extrabold"
                            style={
                                cur
                                    ? { background: ACCENT, color: '#fff', boxShadow: '0 0 0 6px rgb(var(--k-accent-soft))' }
                                    : ok
                                        ? { background: 'rgb(var(--k-ok))', color: '#fff', cursor: 'pointer' }
                                        : locked
                                            ? { background: 'rgb(var(--k-line))', color: 'rgb(var(--k-muted))', cursor: 'not-allowed' }
                                            : { background: 'rgb(var(--k-accent-soft))', color: 'rgb(var(--k-accent-ink))', cursor: 'pointer' }
                            }
                        >
                            {ok ? <CheckIcon style={{ fontSize: 18 }} /> : i + 1}
                        </button>
                        <span className={`text-center text-xs ${cur ? 'font-extrabold text-k-accent-ink' : 'font-semibold text-k-muted'}`}>{label}</span>
                    </li>
                )
            })}
        </ol>
    )
}

export default FormStepper
